// extracted by mini-css-extract-plugin
export default {"wrapper":"KqL263","padder":"QYhApU"};